/**
 * GOAI API 配置
 * 
 * 注意：API Key 和 Secret 使用 base64 编码存储，增加反编译难度。
 * 生产环境建议使用 react-native-config 或原生 Keychain 存储。
 */

// base64 编码的密钥（避免明文存储在代码中）
const ENCODED_API_KEY = 'NEV6YWt0R3VEOGtsYWdOUlRBX3U='
const ENCODED_API_SECRET = 'eXdGNkdaN2VBbWFuSGsxc0EwY2U2dlMxUnQ1UHVxWjFUZXY0UVZjVUw4dz0='
const ENCODED_BASE_URL = 'aHR0cHM6Ly9nb2FpLmZ1aHVpeXVuLmNu'

// 解码函数
const decodeBase64 = (encoded) => {
  try {
    if (typeof Buffer !== 'undefined') {
      // Node.js 环境
      return Buffer.from(encoded, 'base64').toString('utf8')
    } else if (typeof atob !== 'undefined') {
      // 浏览器环境
      return atob(encoded)
    } else {
      // React Native 环境
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
      let output = ''
      let i = 0
      const input = encoded.replace(/[^A-Za-z0-9+/=]/g, '')
      while (i < input.length) {
        const enc1 = chars.indexOf(input.charAt(i++))
        const enc2 = chars.indexOf(input.charAt(i++))
        const enc3 = chars.indexOf(input.charAt(i++))
        const enc4 = chars.indexOf(input.charAt(i++))
        const chr1 = (enc1 << 2) | (enc2 >> 4)
        const chr2 = ((enc2 & 15) << 4) | (enc3 >> 2)
        const chr3 = ((enc3 & 3) << 6) | enc4
        output += String.fromCharCode(chr1)
        if (enc3 !== 64) output += String.fromCharCode(chr2)
        if (enc4 !== 64) output += String.fromCharCode(chr3)
      }
      return output
    }
  } catch (e) {
    console.error('[GOAI Config] Decode error:', e)
    return ''
  }
}

// 导出的配置
export const goaiBaseUrl = decodeBase64(ENCODED_BASE_URL)
export const goaiApiKey = decodeBase64(ENCODED_API_KEY)
export const goaiApiSecret = decodeBase64(ENCODED_API_SECRET)

// 验证配置是否加载成功
if (!goaiApiKey || !goaiApiSecret) {
  console.error('[GOAI Config] 配置加载失败，请检查编码')
}



// WEBPACK FOOTER //
// ./src/util/goaiConfig.js